export function clsx(...args: (string | false | null | undefined)[]): string {
  return args.filter(Boolean).join(" ");
}

export function formatPln(amount: number): string {
  return new Intl.NumberFormat("pl-PL", {
    style: "currency",
    currency: "PLN",
    minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
  }).format(amount);
}

export function clampAmount(value: number, min = 5, max = 10000): number {
  if (Number.isNaN(value)) return min;
  return Math.min(max, Math.max(min, Math.round(value * 100) / 100));
}

/**
 * Reaction tier 0..4 based on amount.
 * Drives MudCarp animation intensity, copy and color cues.
 */
export function reactionTier(amount: number): 0 | 1 | 2 | 3 | 4 {
  if (amount <= 10) return 0;
  if (amount <= 50) return 1;
  if (amount <= 200) return 2;
  if (amount <= 1000) return 3;
  return 4;
}

export const TIER_COPY: Record<0 | 1 | 2 | 3 | 4, { mood: string; tag: string; emojiless: string }> = {
  0: { mood: "lekko olewa", tag: "Drobny szelest", emojiless: "Cisza w karpie" },
  1: { mood: "zerknął okiem", tag: "Mała zachęta", emojiless: "Karp świadomy" },
  2: { mood: "rozkręca się", tag: "Konkretna kasa", emojiless: "Karp zaintrygowany" },
  3: { mood: "włącza tryb wykład", tag: "Powaga sytuacji", emojiless: "Karp w pełnym focusie" },
  4: { mood: "puszcza monolog stulecia", tag: "Maksymalny rozjazd", emojiless: "Karp w transie" },
};
